import { Link } from "react-router-dom";
import { useUser } from "../auth/useUser";
import { Header } from "../components/Header";
import { IdeaForm } from "../components/IdeaForm";

const EXAMPLES = [
  "AI-driven CRM for solo consultants",
  "Voice-first journaling app for runners",
  "Equipment-rental marketplace for film crews in EU",
  "Vendor risk-review automation for compliance teams",
];

export function NewIdea() {
  const { data: user } = useUser();
  if (!user) return null;

  return (
    <div className="min-h-screen flex flex-col">
      <Header
        user={user}
        breadcrumb={
          <>
            <span className="text-ink-600">/</span>
            <Link to="/" className="font-mono text-ink-400 hover:text-ink-200">
              ideas
            </Link>
            <span className="text-ink-600">/</span>
            <span className="font-mono text-ink-300">new</span>
          </>
        }
      />

      <main className="flex-1 flex items-start justify-center px-6 pt-20 pb-24">
        <div className="relative w-full max-w-2xl animate-slide-up">
          <div
            className="pointer-events-none absolute -top-32 left-1/2 h-[400px] w-[600px] -translate-x-1/2 rounded-full opacity-15 blur-3xl"
            style={{
              background: "radial-gradient(circle, rgba(124,122,255,0.6), transparent 70%)",
            }}
          />

          <div className="relative">
            <p className="font-mono text-xs text-ink-400 tracking-widest uppercase mb-3">
              Hi, {user.display_name.split(" ")[0]}
            </p>
            <h1 className="text-display font-medium text-ink-50 tracking-tightest leading-[1.05]">
              What's your idea?
            </h1>
            <p className="mt-4 text-sm text-ink-300 leading-relaxed max-w-xl">
              Describe it in a sentence — the moat, who it's for, what it
              replaces. We'll turn it into a build-ready spec by surfacing the
              gaps and decisions you'll need to answer.
            </p>

            <div className="mt-10">
              <IdeaForm variant="page" examples={EXAMPLES} />
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
